import { analytics } from '@/shared/services/analytics'
import {
  UserPermission,
  type UserFieldsFragment,
} from '@/shared/graphql/legacy/generated'
import { isSignedIn as isUserSignedIn } from '@dacr/auth'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore('user', () => {
  const user = ref<UserFieldsFragment | null>(null)
  const isSignedIn = ref(isUserSignedIn())

  const setUser = (userData: UserFieldsFragment) => {
    user.value = userData
    localStorage.setItem('dacrUser', JSON.stringify(userData))

    analytics.identify(userData.id, {
      name: userData.name,
      email: userData.email,
      username: userData.username,
      isPro: userData.permissions.includes(UserPermission.Pro),
    })
  }

  const updateUser = (userData: Partial<UserFieldsFragment>) => {
    if (!user.value) return
    user.value = { ...user.value, ...userData }
  }

  const reset = () => {
    user.value = null
    isSignedIn.value = false
  }

  return { user, setUser, updateUser, reset, isSignedIn }
})
